import {
  mapLicensesSortToQuery,
  mapLicenseTypeToApi,
} from "~/entity/Licenses/model/licenseQueryParams";
import {
  ILicensesOverviewParams,
  LicensesFilterType,
} from "~/entity/Licenses/model/schema";

import {
  getPartnerFilterValueLabel,
  ILicensesFilter,
} from "./licensesUrlParams";

const FILTER_BY_TO_API: Record<string, LicensesFilterType> = {
  dealer: "organization",
  partner: "partner",
  city: "city",
  region: "region",
  country: "country",
  federalDistrict: "federalDistrict",
};

export const mapLicensesFilterToQuery = (
  page: number,
  count: number,
  filter: ILicensesFilter,
  sortField?: string,
  sortType?: string,
): ILicensesOverviewParams => {
  const filterType = FILTER_BY_TO_API[filter.filterBy];
  const hasFilterValues = Boolean(filterType) && filter.filterValues.length > 0;
  const filterValue = hasFilterValues
    ? filter.filterValues.map((value) =>
        filterType === "partner" ? getPartnerFilterValueLabel(value) : value,
      )
    : undefined;

  return {
    page,
    count,
    inn: filter.inn.trim() || undefined,
    branchCode: filter.branchCode.trim() || undefined,
    licenseType: mapLicenseTypeToApi(filter.licenseType),
    filterType: hasFilterValues ? filterType : undefined,
    filterValue,
    ...mapLicensesSortToQuery(sortField, sortType),
  };
};
